import { useQuery } from '@tanstack/react-query';
import { ServiceJobListRequest } from 'src/api/FiretrolApiClient';
import { serviceJobApiClient } from 'src/api/FiretrolApiClientInstances';
import { queryKeys } from 'src/api/queries/queryKeys';
import { toCancelToken } from 'src/api/queries/queryClient';

/** @registry Every service job in the organization (service-work admins only). */
export function useServiceJobs(request: ServiceJobListRequest = {}) {
  return useQuery({
    queryKey: queryKeys.serviceJobs.list(request),
    queryFn: ({ signal }) =>
      serviceJobApiClient.list(request, toCancelToken(signal)),
    meta: { errorContext: 'service jobs' },
  });
}

/** @registry Service jobs assigned to the signed-in technician. */
export function useMyServiceJobs() {
  return useQuery({
    queryKey: queryKeys.serviceJobs.list({ mine: true }),
    queryFn: ({ signal }) =>
      serviceJobApiClient.getMyServiceJobs(toCancelToken(signal)),
    meta: { errorContext: 'my service jobs' },
  });
}
